import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { Paper, withStyles } from '@material-ui/core'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons'
import Button from 'components/theme/Button'
import errorLocation from './errorLocation'
import language from 'utils/vast-languagepack'

const Dot = connect(
  (state, { step }) => ({
    error:
      errorLocation[step] &&
      (state[errorLocation[step]].validationError ||
        state[errorLocation[step]].validationError === false)
        ? state[errorLocation[step]].validationError
        : false,
  }),
  null
)(({ classes, completed, active, error }) => (
  <div
    className={classNames(classes.dot, {
      [classes.dotError]: error,
      [classes.dotCompleted]: completed,
      [classes.dotActive]: active,
    })}
  />
))

export default withStyles(
  theme => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: '#fff',
      padding: 8,
    },
    dots: {
      display: 'flex',
      flexDirection: 'row',
    },
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: 8,
      height: 8,
      margin: '0 2px',
    },
    dotError: {
      backgroundColor: theme.palette.red,
    },
    dotCompleted: {
      backgroundColor: theme.palette.green,
    },
    dotActive: {
      backgroundColor: theme.palette.orange,
    },
  }),
  { name: 'MuiMobileStepper' }
)(
  ({
    activeStep = 0,
    classes,
    completed,
    handleNext,
    handleBack,
    numberOfSteps,
  }) => (
    <Paper square elevation={0} className={classes.root}>
      <Button
        color="secondary"
        size="small"
        onClick={handleBack}
        disabled={activeStep === 0}
      >
        <KeyboardArrowLeft />
        {language.onboarding.back}
      </Button>
      <div className={classes.dots}>
        {[...new Array(numberOfSteps)].map((_, step) => (
          <Dot
            key={`mobileStepperStep${step}`}
            classes={classes}
            step={step}
            completed={completed[step]}
            active={step === activeStep}
          />
        ))}
      </div>
      <Button
        color="secondary"
        size="small"
        onClick={handleNext}
        disabled={activeStep === numberOfSteps - 1}
      >
        {language.onboarding.next}
        <KeyboardArrowRight />
      </Button>
    </Paper>
  )
)

/* <div
  key={`mobileStepperStep${step}`}
  className={classNames(classes.dot, {
    [classes.dotCompleted]: completed[step],
    [classes.dotActive]: step === activeStep,
  })}
/> */
